export enum DayPortionDTO {
  FULL = 'FULL',
  HALF = 'HALF',
  QUARTER = 'QUARTER',
  HOURLY = 'HOURLY',
}

export enum TimeOffRequestStatusDTO {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
}

export enum ApprovalStatusDTO {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
}

export interface PlannerTimeoffDayResponse {
  date: string;
  portion: DayPortionDTO;
  dayPartNumber: number | null;
  minutes: number;
}

export interface PlannerTimeoffApproverResponse {
  approverId: number;
  approverName: string;
  status: ApprovalStatusDTO;
}

export interface PlannerTimeoffResponse {
  id: number;
  timeOffTypeName: string;
  status: TimeOffRequestStatusDTO;
  description: string | null;
  startDate: string;
  endDate: string;
  days: PlannerTimeoffDayResponse[];
  approvers: PlannerTimeoffApproverResponse[];
}
